import { useAuth } from "@/auth/AuthContext";
import { Button, Modal, Stack, Text, TextInput } from "@mantine/core";
import { isEmail, useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useState } from "react";

interface ForgotPasswordModalProps {
  opened: boolean;
  onClose: () => void;
}

export function ForgotPasswordModal({ opened, onClose }: ForgotPasswordModalProps) {
  const { supabase } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const BASE_URL = import.meta.env.VITE_WEB_BASE_URL;

  const form = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: isEmail("이메일 형식이 올바르지 않습니다"),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setIsLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(values.email, {
        redirectTo: `${BASE_URL}/update-password`,
      });

      if (error) {
        notifications.show({
          title: "오류",
          message: error.message,
          color: "red",
        });
        return;
      }

      notifications.show({
        title: "이메일 전송 완료",
        message: "비밀번호 재설정 링크를 이메일로 보내드렸습니다. 이메일을 확인해주세요.",
        color: "green",
      });

      form.reset();
      onClose();
    } catch (error: any) {
      notifications.show({
        title: "오류",
        message: error.message || "비밀번호 재설정 요청에 실패했습니다.",
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="비밀번호 재설정" centered>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <Text size="sm" c="dimmed">
            가입하신 이메일 주소를 입력해주세요. 비밀번호 재설정 링크를 보내드립니다.
          </Text>
          <TextInput
            label="이메일"
            placeholder="your@email.com"
            {...form.getInputProps("email")}
            size="md"
          />
          <Button type="submit" fullWidth loading={isLoading} mt="md">
            재설정 링크 보내기
          </Button>
        </Stack>
      </form>
    </Modal>
  );
}
